import React from 'react';

import { Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { organizationApi } from 'core/lib/modules/organization/services';
import { UserFilters } from 'core/lib/modules/users/entities/filters';
import LoaderWrapper from 'utils/loader-wrapper';

const { Title } = Typography;

type OrganizationFilterProps = {
  onChange: (filters: Partial<UserFilters>) => void;
  filters: number[] | undefined;
};

const OrganizationFilter = ({ onChange, filters }: OrganizationFilterProps) => {
  const { t } = useTranslation();
  const { data: OrganizationOptions, isFetching: organizationOptionsLoading } =
    organizationApi.useGetUserOrganizationsQuery();

  return (
    <div>
      <Title level={5}>{t('user:filters.organization')}</Title>
      <LoaderWrapper loading={organizationOptionsLoading} message={t('loaders:organization.loadingFilters')}>
        <Select
          mode="multiple"
          className="w-full"
          allowClear
          showSearch={false}
          options={OrganizationOptions}
          value={filters}
          placeholder={t('global:placeholders.selectType', { type: t('user:filters.organization') })}
          onChange={(organizations) => onChange({ organizations })}
        />
      </LoaderWrapper>
    </div>
  );
};

export default OrganizationFilter;
